import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as typeMessages from '../../store/typeMessages'
import MediaQuery from 'react-responsive'

import FlowTable from '../../charts/FlowTable'
import Gauge from '../../charts/Gauge'
import LedStatus from '../../charts/LedStatus'
import Indicator from '../../charts/Indicator'
import ProcessDiagram from './ProcessDiagram'
import MiniChart from '../../charts/MiniChart'
import { LoadingChart, Header } from '../../utils/Utils'
import { Row, Col, Card } from 'antd'

class General extends Component {
  render () {
    let {
      dataVolumen,
      volumenToday,
      pressure,
      slunt1,
      slunt2,
      temperature,
      cfflow,
      energy,
      connect } = this.props

    let header = <Header
      title='Mochileros'
      connect={connect} />

    return (
      <Row type='flex' justify='center' style={{
        filter: `grayscale(${connect ? 0 : 1})`,
        padding: '10px'
      }} gutter={8}>
        <Col span={16} style={{ marginBottom: '8px' }}>
          <Card title={header} bodyStyle={{ padding: '0' }}>
            <ProcessDiagram />
          </Card>
        </Col>
        <Col span={8}>
          <Row type='flex' justify='left' gutter={8}>
            <Col span={12} style={{ marginBottom: '8px' }} align='center'>
              <Card bodyStyle={{ padding: '10px' }}>
                <Indicator
                  width={140}
                  value={energy}
                  type='icon-bolt'
                  title='energy'
                  colors={['#002b4c', '#a0d911']}
                />
              </Card>
            </Col>
            <Col span={12} style={{ marginBottom: '8px' }} align='center'>
              <Card bodyStyle={{ padding: '10px' }}>
                <Indicator
                  width={140}
                  value={temperature}
                  type='icon-thermometer'
                  title='temperature'
                  colors={['#002b4c', '#d4b106']}
                  threshold={[0, Infinity]}
                  unit='&deg;F'
                />
              </Card>
            </Col>
            <Col span={12} style={{ marginBottom: '8px' }} align='center'>
              <Card bodyStyle={{ padding: '10px' }}>
                <Gauge
                  unit='PSI'
                  width={130}
                  stops={[
                    [370, '#a0d911'],
                    [390, '#faad14'],
                    [400, '#f5222d']
                  ]}
                  min={300}
                  max={410}
                  data={pressure.lastValue}
                  title={`PRESSURE`}
                />
              </Card>
            </Col>
            <Col span={6} style={{ marginBottom: '8px' }} align='center'>
              <Card bodyStyle={{ padding: '10px' }}>
                <LedStatus
                  width={50}
                  isOn={!slunt1 ? 0 : 1}
                  onColor='#a0d911'
                  offColor='#002b4c'
                  tittle='Slunt 1'
                />
              </Card>
            </Col>
            <Col span={6} style={{ marginBottom: '8px' }} align='center'>
              <Card bodyStyle={{ padding: '10px' }}>
                <LedStatus
                  width={50}
                  isOn={!slunt2}
                  onColor='#a0d911'
                  offColor='#002b4c'
                  tittle='Slunt 2'
                />
              </Card>
            </Col>
          </Row>
          <MediaQuery minWidth={1919}>
            <Row type='flex' >
              <Col span={24} style={{ marginBottom: '8px' }} align='center'>
                <Card bodyStyle={{ padding: '0' }} >
                  <FlowTable
                    pageSize={7}
                    title='VOLUMEN MOCHILEROS'
                    data={dataVolumen}
                    current={volumenToday} />
                </Card>
              </Col>
            </Row>
          </MediaQuery>
        </Col>
        <Col span={12} style={{ marginBottom: '8px' }}>
          <Card bodyStyle={{ padding: '10px' }}>
            { pressure.populated
              ? <MiniChart
                height={220}
                min={370}
                max={400}
                unit='PSI'
                minrange={1}
                title={'Pressure'}
                data={pressure.data.slice(-30)}
                color='#faad14'
                ylabel='Pounds per square inch'
                type='spline'
              />
              : <LoadingChart height={220} />
            }
          </Card>
        </Col>
        <Col span={12} style={{ marginBottom: '8px' }}>
          <Card bodyStyle={{ padding: '10px' }}>
            { cfflow.populated
              ? <MiniChart
                height={220}
                minrange={0}
                max={100}
                unit='MCF/H'
                title={'CF flow'}
                data={cfflow.data.slice(-30)}
                color='#ffec3d'
                ylabel='Thousand cubic feet per hour'
                type='line'
              />
              : <LoadingChart height={220} />
            }
          </Card>
        </Col>
      </Row>
    )
  }
}

function mapStateToProps (state) {
  let { mochileros } = state.locations
  return {
    slunt1: mochileros.indicators.slunt1.lastValue,
    slunt2: mochileros.indicators.slunt2.lastValue,
    energy: mochileros.indicators.energy.lastValue,
    temperature: mochileros.indicators.temperature.lastValue,
    pressure: mochileros.indicators.pressure,
    cfflow: mochileros.indicators.cfflow,
    dataVolumen: mochileros.indicators.cfvolumen_total_day.data,
    volumenToday: mochileros.indicators.cfvolumen_current_day.lastValue,
    connect: mochileros.connect
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators(typeMessages, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(General)



// WEBPACK FOOTER //
// ./src/boards/mochileros/General.js